export default __webpack_public_path__ + "assets/note-component.b7d35af1.svg";